export default {
  StorageTransactionReport: {
    header: {
      CustomerName: 'Customer Name',
      RecordDate: 'Record Date'
    },
    table: {
      CustomerName: 'Customer Name',
      Storage: 'Storage',
      Pallet: 'Pallet',
      creationDate: 'Date Created'
    },
  }
};
